/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForAzureKubernetesUserManaged extends models.StorageConfigurationForKubernetesUserManaged {
    getFixupPrototypeFunction() { return StorageConfigurationForAzureKubernetesUserManaged.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForAzureKubernetesUserManaged>): StorageConfigurationForAzureKubernetesUserManaged {
        let obj = Object.assign(new StorageConfigurationForAzureKubernetesUserManaged(), model);
        StorageConfigurationForAzureKubernetesUserManaged.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForAzureKubernetesUserManaged>): StorageConfigurationForAzureKubernetesUserManaged {
        if (!model) return null;
        return StorageConfigurationForAzureKubernetesUserManaged.newInstance(<StorageConfigurationForAzureKubernetesUserManaged> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForAzureKubernetesUserManaged) {
        if (!obj) return;

        models.StorageConfigurationForAzureKubernetesUserManaged.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForAzureKubernetesUserManaged): boolean {
        if (models.StorageConfigurationForKubernetesUserManaged.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForAzureKubernetesUserManaged.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Azure Blob Container Name
     */
    container_name: string;

    /**
     * File Path in the Container
     */
    file_path: string;

}
